module.exports = __webpack_public_path__ + "img/WAN.b9e59dae.svg";